var formatPrice = function(price, length) {
  let priceValue = parseFloat(price).toFixed(length);
  let priceValueArray = priceValue.split(".");

  price =
    parseInt(priceValue) === 0
      ? "Offert"
      : priceValueArray[0] + "<small class='priceCents'>," + priceValueArray[1] + " €</small>";

  return (price =
    parseInt(priceValue) <= 0 ? '<span class="priceSpecial">' + price + "</span>" : price);
};

export default formatPrice;
